import React, {Component} from 'react';
import Sdk from 'api.digitalpages.module.sdk.api';
import PouchDB from 'pouchdb-browser';
import $ from "jquery";
import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { BadgesService } from '../../services/badges';
import { CoinsService } from '../../services/coins';
import { UsersService } from '../../services/user';
import { Utils } from '../../utils/utils';
import './course.css';

import {
  Chat,
  DownloadWidget,
  ContentHeader,
  CoinsBox,
  BadgesBox,
  Webview,
  Rating,
  Dialog
} from '../../components';

export default class ViewCourse extends Component {
  constructor(props) {
    super(props);

    this.handleCourseDownloadedUpdated = this.handleCourseDownloadedUpdated.bind(this);

    this.state = {
      "course_info": null,
      "course_tree": null,
      "course_status": null,
      "progress": window.localStorage.getItem(`course-download-progress-${this.props.match.params.courseUid}`),
      "render_chat": false,
      "render_download_widget": false,
      "total_activities": null,
      "total_activities_downloading": [],
      "total_activities_downloaded": [],
      "render_3d_webview": false,
      "unity_rules": {
        "title": "Práticas de Laboratório",
        "url": "https://pocs.digitalpages.com.br/microscopio/"
      },
      "render_rating": false,
      "rtc_token": null,
      "rtm_token": null
    }
  }

  componentWillMount() {
    this.getCourseInfo();
    this.getCourseTree();
    AOS.init({
      offest: -50
    })
    
    // this.getCourseStatus();
  }

  componentDidMount() {
    this.updateDownloadProgress();
    $(".rdp-react-template-view-course-container").scroll(function (event) {
      if ($(".rdp-react-template-view-course-container").scrollTop() > 30) {
        $(".rdp-react-template-view-course-cover-back").fadeOut();
      } else {
        $(".rdp-react-template-view-course-cover-back").fadeIn();
      }
    });
  }
  
  componentWillUnmount() {
    var _this = this;
    window.document.removeEventListener("courseDownloadedUpdated", _this.handleCourseDownloadedUpdated);
  }

  updateDownloadProgress() {
    var _this = this;
    window.document.addEventListener("courseDownloadedUpdated", _this.handleCourseDownloadedUpdated);
  }

  handleCourseDownloadedUpdated(event) {
    const { uid } = event.detail;
    this.getCourseTree();
  }

  redirectTo(path) {
    this.props.history.push(path);
  }

  async getCourseInfo() {
    var unityRules = this.state.unity_rules;
    var courseUid = this.props.match.params.courseUid;
    var courseInfo;
    // var courseInfo = await UsersService.getCourseInfo(courseUid);
    try {
      unityRules = await UsersService.getUnityRules();
    } catch (e) {
      if (window.localStorage.getItem("super-app-unity-rules") !== null) {
        unityRules = JSON.parse(window.localStorage.getItem("super-app-unity-rules"));
      }
    }

    if (Utils.recoverBridge(`/cms/v1.0/learning/course/uid/${courseUid}`) !== null) {
      courseInfo = Utils.recoverBridge(`/cms/v1.0/learning/course/uid/${courseUid}`);
      this.setState({
        "course_info": courseInfo,
        "unity_rules": unityRules
      });
    };

    courseInfo = await Utils.bridgeAndStore(`/cms/v1.0/learning/course/uid/${courseUid}`, null, 'GET')

    this.setState({
      "course_info": courseInfo,
      "unity_rules": unityRules
    });
  }

  injectDownloadProgress(activities) {
    var downloading = [];
    var downloaded = [];

    for (var i = 0; i < activities.length; i++) {
      if (activities[i].local_storage) {
        if (activities[i].local_storage.state === "Downloading") {
          downloading.push(activities[i]);
        };
        if (activities[i].local_storage.state === "Downloaded") {
          downloaded.push(activities[i]);
        };
      };
    };

    this.setState({
      "total_activities": activities,
      "total_activities_downloading": downloading,
      "total_activities_downloaded": downloaded
    })
  }

  getDownloadProgress() {
    const {
      total_activities,
      total_activities_downloaded
    } = this.state;

    // return 50
    // return 100

    if (total_activities !== null && total_activities_downloaded !== null) {
      return total_activities_downloaded.length / total_activities.length * 100
    } else {
      return 0;
    };
  }

  async getCourseTree() {
    var registerUid = this.props.match.params.registerUid;
    var courseTree, courseStatus;

    if (Utils.recoverBridge(`/cms/v1.0/learning/register/uid/${registerUid}/nodes/tree`) !== null &&
      Utils.recoverBridge(`/cms/v1.0/learning/register/uid/${registerUid}/status`) !== null) {
      courseTree = Utils.recoverBridge(`/cms/v1.0/learning/register/uid/${registerUid}/nodes/tree`);
      courseStatus = Utils.recoverBridge(`/cms/v1.0/learning/register/uid/${registerUid}/status`)

      this.manipulateCourseTree(courseTree, courseStatus);
    };

    courseTree = await Utils.bridgeAndStore(`/cms/v1.0/learning/register/uid/${registerUid}/nodes/tree`, null, 'GET');
    courseStatus = await Utils.bridgeAndStore(`/cms/v1.0/learning/register/uid/${registerUid}/status`, null, 'GET');

    this.manipulateCourseTree(courseTree, courseStatus);
  }

  manipulateCourseTree(courseTree, courseStatus) {
    var activities = courseStatus.activities;
    this.injectDownloadProgress(activities);

    var treeWithInteractions = this.mergeNodesAndInteractions(courseTree, courseStatus.activities);

    for (var i = 0; i < treeWithInteractions.length; i++) {
      var nodes = treeWithInteractions[i].childs;
      treeWithInteractions[i].activities = [];
      for (var j = 0; j < nodes.length; j++) {
        var acts = nodes[j].activities;
        for (var k = 0; k < acts.length; k++) {
          for (var l = 0; l < activities.length; l++) {
            if (acts[k].uid === activities[l].uid) {
              acts[k].status = activities[l].status;
            };            
          };
          treeWithInteractions[i].activities.push(acts[k]);
        };
      };

      treeWithInteractions[i].progress = treeWithInteractions[i].activities.filter(acStatus => acStatus.status === "Completed").length / treeWithInteractions[i].activities.length * 100
    }

    this.setState({
      "course_tree": treeWithInteractions,
      "course_status": courseStatus
    });
  }

  mergeNodesAndInteractions(tree, statusActivities) {
    for (var i = 0; i < tree.length; i++) {
      var firstActivities = tree[i].activities;
      var firstChilds = tree[i].childs;

      for (var j = 0; j < statusActivities.length; j++) {
        for (var k = 0; k < firstActivities.length; k++) {
          if (statusActivities[j].uid === firstActivities[k].uid) {
            firstActivities[k].interaction_uid = statusActivities[j].interaction_uid;
          };
        };

        for (var l = 0; l < firstChilds.length; l++) {
          var secondActivities = firstChilds[l].activities;

          for (var m = 0; m < secondActivities.length; m++) {
            if (secondActivities[m].uid === statusActivities[j].uid) {
              secondActivities[m].interaction_uid = statusActivities[j].interaction_uid;
            };
          };
        };
      };
    };

    return tree;
  }

  async getCourseStatus() {
    var registerUid = this.props.match.params.registerUid;
    // var courseStatus = await UsersService.getCourseStatus(registerUid);
    var courseStatus = await Sdk.Api.dynamic.bridge(`/cms/v1.0/learning/register/uid/${registerUid}/status`, null, 'GET');

    this.setState({
      "course_status": courseStatus
    });
  }

  async downloadCourse() {
    var _this = this;
    var db = new PouchDB('rdp_database');
    var toDownload = 0;
    var downloaded = 0;
    var assets = [];
    var activities = [];
    var course_tree = this.state.course_tree;
    var course_status = this.state.course_status;
    var token = "";
    var courseUid = this.props.match.params.courseUid;

    var acts = course_status.activities;
    for (var i = 0; i < acts.length; i++) {
      await UsersService.getContentByInteraction(acts[i].interaction_uid);
    };
    // getContentByInteraction

    for (var i = 0; i < course_tree.length; i++) {
      // if (course_tree[i].activities !== undefined) activities = activities.concat(course_tree[i].activites);
      for (var j = 0; j < course_tree[i].childs.length; j++) {
        if (course_tree[i].childs[j].activities !== undefined) activities = activities.concat(course_tree[i].childs[j].activities);
      };
    };

    for (var i = 0; i < activities.length; i++) {
      toDownload += 1;
      activities[i].to_download = activities;
      var contentOptions = await UsersService.getContentByInteraction(activities[i].interaction_uid);
      var url = `${contentOptions.activity.url}&access_token=${contentOptions.access_token}`;
      var content = await UsersService.getContent(url);

      token = contentOptions.access_token;
      try {
        var saved = await db.put({
          _id: contentOptions.activity.url.split("uid=")[1],
          title: contentOptions.activity.url.split("uid=")[1],
          course_uid: courseUid,
          composition: JSON.stringify(content),
          mimetype: "digitalpages/composer"
        });
      } catch (err) {
        console.log(err);
      };

      downloaded += 1;

      if (contentOptions.activity.mime_type === "digitalpages/composer") {
        toDownload += content.assets.length;
        assets = assets.concat(content.assets);
      };
      activities[i].content_options = contentOptions;
    };


    for (var i = 0; i < assets.length; i++) {
      var asset = await this.makeRequest(`${assets[i]}&access_token=${token}`);
      // var blob = new Blob([asset.arraybuffer], {type: asset.mimetype});
      try {
        var saved = await db.put({
          _id: assets[i].split("uid=")[1].split("&")[0],
          title: assets[i].split("uid=")[1].split("&")[0],
          course_uid: courseUid,
          arraybuffer: asset.arraybuffer,
          mimetype: asset.mimetype
        });
      } catch (err) {
        console.log(err);
      };
      
      downloaded += 1;

      _this.setState({"progress": Math.floor(downloaded / toDownload * 100)})

      window.localStorage.setItem(`course-download-progress-${courseUid}`, Math.floor(downloaded / toDownload * 100))
    };

    // var asset = await this.makeRequest(`${assets[i]}&access_token=${token}`);

    // var blob = new Blob([asset.arraybuffer], {type: asset.mimetype});
    // var objectUrl = URL.createObjectURL(blob);
    // window.open(objectUrl);

    alert("BAIXADO!")
  }

  makeRequest (url) {
    return new Promise(function (resolve, reject) {
      var mimetype = "";
      var xhr = new XMLHttpRequest();
      xhr.open("GET", url);
      xhr.responseType = "arraybuffer";

      xhr.onreadystatechange = function (e) {
        mimetype = this.getResponseHeader('content-type');
      };
      xhr.onload = function () {
        if (xhr.status >= 200 && xhr.status < 300) {
          resolve({
            "mimetype": mimetype,
            "arraybuffer": xhr.response
          });
        } else {
          reject({
            status: xhr.status,
            statusText: xhr.statusText
          });
        }
      };
      xhr.onerror = function () {
        reject({
          status: xhr.status,
          statusText: xhr.statusText
        });
      };
      xhr.send();
    });
  }

  async openPlayer(mod) {
    const {
      unity_rules
    } = this.state;

    if (mod.data && mod.data.title === unity_rules.title) {
      var activity = mod.activities.find(act => act.name === mod.data.title);
      var interactionUid = activity.interaction_uid;
      var contentOptions = await Sdk.Api.dynamic.bridge(`/cms/v1.0/learning/interaction/uid/${interactionUid}/content/options`, null, 'GET');
      var options = btoa(JSON.stringify(contentOptions));
      fetch(`app://0.0.0.1/proxy/system/action?event=unity&custom_options=${options}`);
      // this.setState({
      //   "render_3d_webview": true
      // })
    } else {
      var activity = null;
      var courseUid = this.props.match.params.courseUid;
      var registerUid = this.props.match.params.registerUid;
      var moduleUid = mod.uid;
  
      var activityUid = mod.childs && mod.childs.length > 0 && mod.childs[0].activities[0].uid;
  
      this.redirectTo(`/player/${courseUid}/${registerUid}/${moduleUid}/${activityUid}`);
    }
  }

  onToggleChat() {
    this.setState({
      "render_chat": !this.state.render_chat
    })
  }

  onCloseDownloadWidget() {
    this.setState({
      "render_download_widget": false
    })
  }
  
  onOpenDownloadWidget() {
    this.setState({
      "render_download_widget": true
    });
    this.onDownloadCourse();
  }

  async onDownloadCourse() {
    var registerUid = this.props.match.params.registerUid;
    var courseStatus = await Sdk.Api.dynamic.bridge(`/cms/v1.0/learning/register/uid/${registerUid}/status`, null, 'GET', 'json', {
      "Mobile-Download": "Permanent"
    });
  }

  async onRemoveCourse() {
    var registerUid = this.props.match.params.registerUid;
    var courseStatus = await Sdk.Api.dynamic.bridge(`/cms/v1.0/learning/register/uid/${registerUid}/status`, null, 'GET', 'json', {
      "Mobile-Download": "Delete"
    });
  }

  onToggleRating() {
    this.setState({
      "render_rating": !this.state.render_rating
    })
  }

  render() {
    var _this = this;
    const {
      render_chat,
      render_download_widget,
      progress,
      course_info,
      course_tree,
      render_3d_webview,
      unity_rules,
      total_activities_downloading,
      render_rating,
    } = this.state;


    return <div className="rdp-react-template-view-course">
      <div className="rdp-react-template-view-course-cover" style={{backgroundImage: course_info && course_info.thumb_url && `url(${course_info.thumb_url})`}}>
        <span className="rdp-react-template-view-course-cover-back" onClick={() => this.redirectTo("/feed")}></span>
      </div>
      <div className="rdp-react-template-view-course-container">
        <div className="rdp-react-template-view-course-content">
          <h1 data-aos="fade-up" data-aos-duration="1000" data-aos-delay="200">{course_info && course_info.title}</h1>
          <div className="rdp-react-template-view-course-content-actions" data-aos="fade-up" data-aos-duration="1200" data-aos-delay="200">
            <button className={`rdp-react-template-view-course-content-action only-online`} onClick={() => this.onToggleChat()}>
              <span className="rdp-react-template-view-course-content-action-icon chat"></span>
              <span className="rdp-react-template-view-course-content-action-label">Chat</span>
            </button>
            <button className={`rdp-react-template-view-course-content-action only-online`} onClick={() => this.onOpenDownloadWidget()}>
              <span className="rdp-react-template-view-course-content-action-icon download"></span>
              <span className="rdp-react-template-view-course-content-action-label">Download</span>
            </button>
            {/* <button className={`rdp-react-template-view-course-content-action only-online`} onClick={() => this.onToggleRating()}>
              <span className="rdp-react-template-view-course-content-action-number">4.5</span>
              <Rating
                count={5}
                rating={4.5}
                starWidth={10}
              />
            </button> */}
          </div>

          <h4 className="rdp-react-template-view-course-content-subtitle" data-aos="fade-up" data-aos-duration="1400" data-aos-delay="400">Sobre este Curso</h4>
          <div className="rdp-react-template-view-course-content-description" data-aos="fade-up" data-aos-duration="1600" data-aos-delay="400">
            {course_info && course_info.description}
          </div>
          {progress && <div className="rdp-react-template-view-course-content-download-progress">{progress}%</div>}
          {/* <button className="rdp-react-template-view-course-content-download-btn" onClick={() => this.downloadCourse()}>Download do curso</button> */}
          <h4 className="rdp-react-template-view-course-content-subtitle" data-aos="fade-up" data-aos-duration="1800" data-aos-delay="600">Trilha de Aprendizagem</h4>
          <ul className="rdp-react-template-view-course-content-modules" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="600">
            {course_tree && course_tree.map(function (item, index) {
              return <li key={index} className="rdp-react-template-view-course-content-module" onClick={() => _this.openPlayer(item)}>
                <div className="rdp-react-template-view-course-content-module-number">{index + 1}</div>
                <div className="rdp-react-template-view-course-content-module-data">
                  <span className="rdp-react-template-view-course-content-module-data-title">{item.data.title}</span>
                  {/* <span className="rdp-react-template-view-course-content-module-data-quantity">4 atividades</span> */}
                </div>
                <span className={`rdp-react-template-view-course-content-module-play ${item.data.title === unity_rules.title ? "three-d" : ""} ${item.progress === 100 ? "done" : ""} ${(item.progress > 0 && item.progress < 100) ? "in_progress" : ""}`}>
                  <div style={{ width: 50, height: 50, marginTop: "-1px", marginLeft: "-1px" }}>
                    {item.progress > 0 && item.progress < 100 &&
                      <CircularProgressbar
                        value={item.progress}
                        strokeWidth={2}
                        styles={{
                          path: {
                            stroke: "#ff9132",
                            strokeLinecap: 'butt',
                          },
                          trail: {
                            stroke: '#2c2d31',
                            strokeLinecap: 'butt',
                          }
                        }}
                      />
                    }
                  </div>
                </span>
              </li>
            })}
          </ul>
        </div>
      </div>

      {render_chat &&
        <Chat
          onBack={() => this.onToggleChat()}
          context="offer"
          contextUid={this.props.match.params.registerUid}
        />
      }
      {render_download_widget &&
        <DownloadWidget
          downloadingLength={total_activities_downloading.length}
          progress={this.getDownloadProgress()}
          onClose={() => this.onCloseDownloadWidget()}
          onDownload={() => this.onDownloadCourse()}
          onRemove={() => this.onRemoveCourse()}
        />
      }

      {render_3d_webview &&
        <Webview
          title={unity_rules.title}
          url={unity_rules.url}
          onBack={() => {
            this.setState({"render_3d_webview": false})
          }}
        />
      }

      {render_rating &&
        <Dialog
          titleFontSize="25px"
          type="rating"
          fullscreen={true}
          title="Avalie este curso!"
          onClose={() => this.onToggleRating()}
          onConfirm={() => this.onBack()}
        />
      }
    </div>;
  }
}
